import { createSlice } from "@reduxjs/toolkit";

const adultSlice = createSlice({
  name: "adult",
 initialState: {
  adultFormData: {
    AdultData: [],  // Note the capitalization
    source: ""
  }
  },
  reducers: {
    setAdultFormData: (state, action) => {
      state.adultFormData = action.payload;
    },

    updateAdultSource: (state, action)=> {
  state.source = action.payload;

  // Fix: Access nested NumeracyData array
  if (Array.isArray(state.NumeracyData?.NumeracyData)) {
    state.NumeracyData.NumeracyData = state.NumeracyData.NumeracyData.map(item => ({
      ...item,
      source: action.payload,
    }));
  }
}
,

    updateAdultData: (state, action) => {
      state.adultFormData.AdultData = action.payload;
    },

    updateAdultDataYear: (state, action) => {
      state.adultFormData.AdultData = state.adultFormData.adultData.map((item) => ({
        ...item,
        Census_Year: action.payload,
      }));
    },

    updateAdultDataProvince: (state, action) => {
      state.adultFormData.AdultData = state.adultFormData.adultData.map((item) => ({
        ...item,
        Province_Id: action.payload,
      }));
    },
  },
});

export const {
  setAdultFormData,
  updateAdultSource,
  updateAdultData,
  updateAdultDataYear,
  updateAdultDataProvince,
} = adultSlice.actions;

export default adultSlice.reducer;
